import { useState } from 'react';
import type { LimitType } from '../types/limitType.types';

export function useLimitTypeActionModals() {
  const [limitTypeToEdit, setLimitTypeToEdit] = useState<LimitType | null>(null);

  return {
    limitTypeToEdit,
    openEditModal: setLimitTypeToEdit,
    closeModal: () => setLimitTypeToEdit(null),
  };
}
